import { ButtonV2, ButtonV2Props, Flex, styled, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledPriceRangeWrapper = styled(Flex)``;
const priceRangeWrapperStyles: StyleSystemProps = {
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const StyledTextWrapper = styled(Flex)``;
const textWrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  marginTop: 3,
  alignItems: 'center',
};

export const StyledButton = styled(ButtonV2)``;
const buttonStyles: ButtonV2Props = {
  intent: 'neutral',
  shape: 'rounded',
  variant: 'outline',
  height: pxToRem(32),
  width: pxToRem(80),
  marginTop: 4,
  marginX: { _: 'auto' },
};

export const styles = {
  priceRangeWrapper: priceRangeWrapperStyles,
  textWrapper: textWrapperStyles,
  button: buttonStyles,
};
